import { render } from "./DepositCryptoModal.vue?vue&type=template&id=d8f3aa40&scoped=true"
import script from "./DepositCryptoModal.vue?vue&type=script&lang=js"
export * from "./DepositCryptoModal.vue?vue&type=script&lang=js"

import "./DepositCryptoModal.vue?vue&type=style&index=0&id=d8f3aa40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8f3aa40"]])

export default __exports__